/**
 * Abre um registro de presença em NOVA ABA, na rota do status ATUAL dele (D-W3).
 *
 * A tela de auditoria decide "aprovado" pela ROTA, e o histórico não sabe o status atual da
 * contraparte (pode ter sido revertida depois). Por isso: abre a aba DENTRO do clique
 * (síncrono — depois de um `await` o navegador bloqueia o pop-up), busca o status e só então
 * aponta a aba para o caminho certo.
 */
import Network from '@/Network'
import { pathForStatus } from '@/modules/company/Approvals/DsAttendance/utils/status-route-map'
import { ServiceError } from '@/utils/apiError'

export async function openDsAttendanceContainerInNewTab(containerId: number): Promise<void> {
  const tab = window.open('', '_blank')
  if (!tab) {
    throw new ServiceError(
      'O navegador bloqueou a nova aba. Libere pop-ups para este site e tente de novo.'
    )
  }
  try {
    const detail = await Network.dsAttendance.getById(containerId)
    tab.opener = null
    tab.location.href = pathForStatus(containerId, detail?.status ?? null)
  } catch (error) {
    tab.close()
    throw error
  }
}
